import React from 'react';
import { Link } from 'react-router-dom';
import { AppState } from 'acscp/store';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import style from './pageTitle.module.scss';
import { ArrowIcon } from './icons/arrowIcon';
import { Background, Row } from './row';
import { GoBackLink } from 'acscp/components/common/goBackLink';
import { PresentationComponentBase } from 'acscp/components/presentationComponentBase';
import { userIsLoggedIn } from 'acscp/store/helpers/authHelper';
import { home } from 'acscp/components/routeHelper';

interface PageTitleStateProps {
    isLoggedIn: boolean;
}

interface PageTitleOwnProps {
    title: any;
    goBackAddress?: string;
}

class PageTitlePresentational extends PresentationComponentBase<PageTitleOwnProps, PageTitleStateProps, {}, {}> {
    render(): JSX.Element {
        const goBackAddress = this.props.goBackAddress || home();
        return (
            <Row background={Background.LightestGrey} className={style.PageTitleBar}>
                <GoBackLink className={style.BackToHome} fallbackAddress={goBackAddress}>
                        <ArrowIcon />
                </GoBackLink>
                <div className={style.PageTitle}>
                    {this.props.title}
                </div>
                <div className={style.FlexPadding}/>
                <div className={style.RightAlignedBox}>
                    {this.props.children}
                </div>
            </Row>
        );
    }
}

function mapStateToProps(state: AppState, ownProps: {}): PageTitleStateProps {
    return {
        isLoggedIn: userIsLoggedIn(state.auth)
    };
}

export const PageTitle = connect(mapStateToProps)(PageTitlePresentational);
